import {
  useEffect,
  useLayoutEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import { Card, Modal, Badge, Dropdown } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import Select from "react-select";
// import ReactStars from "react-rating-stars-component";
import Heart from "react-heart";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  CustomGetAPI,
  GetAPI,
  PostAPI,
  PutAPI,
  CustomPostAPI,
} from "../Utils/APIConnector";
import {
  capitalizeWord,
  formatDateToInput,
  venueSportsData,
} from "../Utils/common";
import _ from "lodash";
import Loader from "../Utils/Loader";
import VerifyPhoneNumber from "../VerifyPhoneNumber";
import HelmetMetaTag from "../Utils/HelmetMetaTag/HelmetMetaTag";
import LazyLoadingImg from "../LazyLoading/LazyLoadingImg";
import InfiniteScroll from "react-infinite-scroll-component";
import LocationSearch from "../SearchModal/LocationSearch";
import DatePicker from "react-datepicker";
import VoiceSearchFeature from "./VoiceSearchFeature";

const sportsButtonData = [
  { image: null, sportsBtnText: "All sports" },
  { image: "/images/sport-box-cricket.svg", sportsBtnText: "Cricket" },
  { image: "/images/sport-football.svg", sportsBtnText: "Football" },
  { image: "/images/sport-box-cricket.svg", sportsBtnText: "Box-cricket" },
  { image: "/images/sport-pickleball.svg", sportsBtnText: "Pickleball" },
  { image: "/images/sport-gokarting.svg", sportsBtnText: "Go karting" },
];

const TimingsButtonData = [
  {
    value: "1",
    TimimgImage: "/images/before-5am.svg",
    TimingBtnText: "Before 5am",
  },
  {
    value: "2",
    TimimgImage: "/images/5am-12pm.svg",
    TimingBtnText: "5am to 12pm",
  },
  {
    value: "3",
    TimimgImage: "/images/12pm-6pm.svg",
    TimingBtnText: "12pm to 6pm",
  },
  {
    value: "4",
    TimimgImage: "/images/after-6pm.svg",
    TimingBtnText: "After 6pm",
  },
];

export default function NewVenueListing() {
  const prevCity = localStorage.getItem("userLocation");
  const params = useParams();
  const location = useLocation();
  const userID = localStorage.getItem("userid");
  // const [CityAreaName?.city, setcityNames] = useState("")
  // const [CityAreaName?.area, setAreaName] = useState("")
  const [CityAreaName, setCityAreaName] = useState({ city: "", area: "" });
  const [CityAreaArray, setCityAreaArray] = useState([]);
  const [initialLoad, setInitialLoad] = useState(false);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const navigate = useNavigate();
  const { pathname } = location;
  const CreateOwnMatchDate = location?.state?.Date;
  const selectedDate = CreateOwnMatchDate ? CreateOwnMatchDate : null;

  const [sportId, setSportId] = useState();
  const [areaData, setAreaData] = useState();
  const [selecedArea, setSelecedArea] = useState();

  const [sportsOptions, setSportsOptions] = useState();
  const [isSticky, setIsSticky] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const initialFilterObjects = JSON.parse(
    localStorage.getItem("filterObjects")
  ) || {
    name: "",
    sport: "0",
    timings: [],
    amenities: "0",
    date: selectedDate,
    sortby: "0",
    area: "",
  };
  // const [sportsIds, setSportsIds] = useState([])
  const [filterObjects, setFilterObjects] = useState(initialFilterObjects);
  useEffect(() => {
    if (new Date(filterObjects?.date) < new Date()) {
      setFilterObjects((prev) => ({
        ...prev,
        date: null,
      }));
    }
  }, []);
  useLayoutEffect(() => {
    CustomGetAPI("/venue/GetAllCity").then((result) => {
      result = JSON.parse(result);
      if (result?.status === "success") {
        setCityAreaArray(result?.cities);
        const slugify = (name) => name.toLowerCase().replace(/\s+/g, "-");
        const areaParts = params?.cityName;

        const sortedCities = [...result?.cities].sort(
          (a, b) => b.cityName.length - a.cityName.length
        );

        for (const city of sortedCities) {
          const citySlug = slugify(city.cityName);
          if (areaParts.endsWith(citySlug)) {
            const cityName = city.cityName.toLowerCase();
            const areaSlug = areaParts
              .slice(0, -citySlug.length)
              .replace(/-$/, "");

            setCityAreaName({ city: cityName, area: areaSlug });
            const updatedFilter = JSON.parse(
              localStorage.getItem("filterObjects")
            ) || {
              name: "",
              sport: "0",
              timings: [],
              amenities: "0",
              date: selectedDate,
              sortby: "0",
              area: [],
            };

            let areaArray = [];

            if (!prevCity?.trim() || !cityName?.trim()) {
              areaArray = [];
            } else if (prevCity?.toLowerCase() !== cityName) {
              areaArray = areaSlug?.trim() ? [areaSlug] : [];
            } else if (areaSlug?.trim()) {
              areaArray = [areaSlug];
            } else {
              areaArray = Array.isArray(updatedFilter.area)
                ? updatedFilter.area.filter((a) => a.trim() !== "")
                : [];
            }

            updatedFilter.area = areaArray;
            if (areaSlug === "" && selectedAreas.length === 1) {
              if (selectedAreas.length >= 1) {
                updatedFilter.area = [];
              }
            }

            setPageNumber(1);
            setVenuesData([]);
            setSelectedAreas(updatedFilter.area);
            setInitialLoad(true);
            setFilterObjects(updatedFilter);
            localStorage.setItem(
              "filterObjects",
              JSON.stringify(updatedFilter)
            );
            localStorage.setItem("userLocation", cityName);

            return;
            // setcityNames(cityName);
            // const stored = JSON.parse(localStorage.getItem("filterObjects")) || {
            //   name: "",
            //   sport: "0",
            //   timings: [],
            //   amenities: "0",
            //   date: selectedDate,
            //   sortby: "0",
            //   area: [],
            // };

            // if (areaSlug && stored?.area && stored?.area?.length === 0) {
            //   let areaArray = Array.isArray(stored.area) ? stored.area.filter(a => a.trim() !== "") : [];
            //   if (areaSlug && !areaArray.includes(areaSlug)) {
            //     areaArray.push(areaSlug);
            //   }
            //   areaArray = areaArray.filter(a => a.trim() !== "");
            //   stored.area = areaArray;
            //   setPageNumber(1);
            //   setVenuesData([]);
            //   setSelectedAreas(areaArray);
            //   localStorage.setItem("filterObjects", JSON.stringify(stored));
            // } else {
            //   setPageNumber(1);
            //   setVenuesData([]);
            //   setSelectedAreas(stored.area);
            //   localStorage.setItem("filterObjects", JSON.stringify(stored));
            // }
            // setInitialLoad(true)
            // window.localStorage.setItem("userLocation", cityName);
            // // setAreaName(areaSlug);
            // return;
          }
        }
      }
    });
  }, [params?.cityName]);

  const CityName = params?.cityName;

  const [packageData, setPacakgeData] = useState();
  useLayoutEffect(() => {
    if (CityAreaName?.city) {
      CustomGetAPI(
        `/Packages/PackageByID/0/0?cityname=${CityAreaName?.city}`
      ).then((result) => {
        result = JSON.parse(result);
        if (result && result?.status == "Success") {
          setPacakgeData(result?.packages[0]);
        }
      });
      window.scrollTo(0, 0);
    }
  }, [CityAreaName]);

  useLayoutEffect(() => {
    if (CityAreaName?.city) {
      CustomGetAPI(
        `/venue/uniqueaddresses/${CityAreaName?.city}?category=${
          pathname?.split("/")[3]
        }`
      ).then((result) => {
        result = JSON.parse(result);
        if (result?.status === "success") {
          setAreaData(result?.data);
        }
      });
    }
  }, [CityAreaName?.city]);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset >= 60) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    // console.log(CityName);
    if (CityName == "thane-mumbai") {
      window.location.href = window.location.pathname.replace(
        "thane-mumbai",
        "thane"
      );
    }
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const handleAreaChange = (areas) => {
    // if (
    //   selecedArea?.replaceAll("-", " ").toLocaleLowerCase() ===
    //   area.toLocaleLowerCase()
    // ) {
    //   //setSelecedArea(null);
    //   area = "";
    //   setFilterObjects((prevState) => ({
    //     ...prevState,
    //     area: "",
    //   }));
    // } else {
    setFilterObjects((prevState) => ({
      ...prevState,
      area: areas,
    }));
    // }
    filterVenues(null, null, null, null, areas);
  };
  // const ratingChanged = (newRating) => {
  //   console.log(newRating);
  // };

  const [active, setActive] = useState(false);
  // const [heartState,setheartState] = useState([])
  const [Filter, setFilter] = useState(false);
  const [venuesData, setVenuesData] = useState([]);
  const [SportsData, setSportsData] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [speechRecognitionModal, setSpeechRecognitionModal] = useState(false);
  // const [cityValue, setCityValue] = useState('')

  const [isLoading, setIsLoading] = useState(true);

  const [layout, setLayout] = useState("single");
  const [areaText, setAreaText] = useState("");
  const [availableLetters, setAvailableLetters] = useState([]);
  const [hoveredAlphabet, setHoveredAlphabet] = useState("");
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [showAreas, setShowAreas] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [selectTimings, setSelectTimings] = useState([]);
  const [showSearchList, setShowsearchList] = useState(false);
  const [HasMore, setHasMore] = useState(false);
  const [PageNumber, setPageNumber] = useState(1);
  const [selectedOption, setSelectedOption] = useState("Filters");
  const [activeSport, setActiveSport] = useState(filterObjects?.sport || "0");
  const [activeTime, setActiveTime] = useState(
    filterObjects?.timings?.value || "0"
  );
  const [selectedSort, setSelectedSort] = useState(filterObjects.sortby || "0");
  const userLocation = window.localStorage.getItem("userLocation");
  const [selectedCity, setSelectedCity] = useState(userLocation);
  const [isSearch, setIsSearch] = useState(false);
  const SearchRef = useRef(null);
  const FilterRef = useRef(null);
  const redirectURL = window.localStorage.getItem("RedirectURL");

  const options = [
    { value: "1", label: "Early Morning(Before 5am)" },
    { value: "2", label: "Morning(05:00am-12:00pm)" },
    { value: "3", label: "Afternoon(12:00pm-6:00pm)" },
    { value: "4", label: "Evening(After 6pm)" },
  ];

  const handleSelectTimings = (selectedTime) => {
    setActiveTime(selectedTime);
    const selectedData = TimingsButtonData?.find(
      (time) => time?.value === selectedTime
    );
    if (selectedData) {
      setFilterObjects((prevState) => ({
        ...prevState,
        timings: {
          value: selectedData?.value,
          TimingBtnText: selectedData?.TimingBtnText,
        },
      }));
    }
  };

  const handleVenueListing = (name) => {
    window.localStorage.setItem(
      "venueRedirectURL",
      "/venue-search" +
        "/" +
        CityName.toLocaleLowerCase() +
        `/${pathname?.split("/")[3]}/${params.sportName.toLocaleLowerCase()}`
    );
  };

  const goToVenueSearch = () => {
    // window.location.href = "/home";
    //let venueURL = window.localStorage.getItem("venueRedirectURL") || "/home";
    navigate("/home");
  };

  // const goToVenueList = (id, name) => {
  //   setSearchText(name);
  //   setShowsearchList(false);
  //   window.localStorage.setItem(
  //     "venueUrl",
  //     `/venue-search/${name.toLocaleLowerCase()}/${pathname?.split("/")[3]}/all`
  //   );
  //   window.location.href = `/venue-search/${name.toLocaleLowerCase()}/${pathname?.split("/")[3]
  //     }/all`;
  // };
  const toggleFilters = (e) => {
    e.stopPropagation();
    setFilter(!Filter);
    if (!Filter) {
      document.body.classList.add("no-scroll");
      document.getElementsByClassName("filter-bg")[0].classList.add("blur-bg");
    } else {
      document.body.classList.remove("no-scroll");
      document
        .getElementsByClassName("filter-bg")[0]
        .classList.remove("blur-bg");
    }
  };

  const [sportName, setsportName] = useState();
  const handleChange = (e) => {
    if (e.target.name === "sport") {
      setsportName(e.target.label);
    }

    let val = { ...filterObjects };
    val[e.target.name] = e.target.value;
    setFilterObjects(val);

    // if (e.target.name === "date") {
    //   filterVenues(e.target.value);
    // }
  };

  const handleNameSearch = (e) => {
    delayedNameSearch(e.target.value);
  };

  const toggleLayout = () => {
    setLayout((prevState) => (prevState === "single" ? "multiple" : "single"));
  };

  async function resetFilter() {
    setIsLoading(true);
    setFilter(false);
    document.body.classList.remove("no-scroll");
    document.getElementsByClassName("filter-bg")[0].classList.remove("blur-bg");
    setFilterObjects({
      name: "",
      sport: 0,
      date: selectedDate,
      timings: "",
      sortby: "0",
      area: [],
    });
    localStorage.removeItem("filterObjects");
    // setFilterData(venuesData);
    const currentPath = window.location.pathname;
    const parts = currentPath.split("/");
    const newLocation = parts.slice(0, parts.length - 1).join("/") + `/all`;

    window.location.href = newLocation;
    const raw = JSON.stringify({
      UserId: userID ? userID : 0,
      cityname: CityAreaName?.city,
      Name: "",
      Sport: 0,
      Date: selectedDate,
      TimeId: "",
      Sortby: "0",
    });
  }

  async function filterVenues(
    date,
    sortby,
    sport,
    sportname,
    area = selectedAreas,
    location = null
  ) {
    if (date) {
      filterObjects.date = date.toLocaleString("sv-SE").replace(" ", "T");
    } else if (location) {
      filterObjects.date = null;
    } else {
      filterObjects.date = filterObjects?.date
        ?.toLocaleString("sv-SE")
        ?.replace(" ", "T");
    }
    if (sortby) {
      filterObjects.sortby = sortby;
    }
    if (sport || sport == 0) {
      filterObjects.sport = sport;
    }
    if (sportname === `All-${capitalizeWord(pathname?.split("/")[3])}`) {
      sportname = "all";
    }
    if (area?.length === 0) {
      filterObjects["area"] = [];
    } else {
      filterObjects["area"] = Array.isArray(area) ? area : [area.toLowerCase()];
    }
    if (area?.length === 1) {
      area = area[0];
    } else if (!location) area = "";
    setIsLoading(true);
    setFilter(false);
    document.body.classList.remove("no-scroll");
    document.getElementsByClassName("filter-bg")[0].classList.remove("blur-bg");
    localStorage.setItem("filterObjects", JSON.stringify(filterObjects));
    const city = location
      ? location.toLowerCase().replaceAll(" ", "-")
      : CityAreaName?.city?.toLowerCase().replaceAll(" ", "-") || "";
    // const areas = location ? area.toLowerCase() : CityAreaName?.area?.toLowerCase().replaceAll(" ", "-") || "";
    const sports =
      sportname?.toLowerCase() ||
      sportName?.toLowerCase() ||
      params.sportName.toLowerCase();
    // const newLocation = `/venue-/${areas}${areas && "-"}${city}/sports/${sports}`;
    const newLocation = `/venue-search/${city}/sports/${sports}`;
    window.location.href = newLocation;
  }

  useLayoutEffect(() => {
    if (CityAreaName?.city) {
      CustomGetAPI(
        `/Venue/GetCitiesAreaStatus/${
          CityAreaName?.area ? CityAreaName?.area?.replaceAll("-", " ") : null
        }/${CityAreaName?.city}`
      ).then((result) => {
        if (result === undefined || result === "") {
          alert("Something went wrong");
        } else {
          result = JSON.parse(result);
          if (!result?.isCityArea) {
            navigate("/not-found");
          } else {
            setSearchText(capitalizeWord(CityName, "-", ", "));
          }
        }
      });
    }
  }, [CityAreaName]);

  // useLayoutEffect(() => {
  // if (CityAreaName?.area && selectedAreas?.length === 1) {
  //   setFilterObjects((prevState) => ({
  //     ...prevState,
  //     area: [CityAreaName?.area],
  //   }));
  //   const filterobject = filterObjects;
  //   filterobject["area"] = [CityAreaName?.area];
  //   if (filterobject["date"] !== null) {
  //     filterobject["date"] = filterObjects?.date
  //       ?.toLocaleString("sv-SE")
  //       ?.replace(" ", "T");
  //   }
  //   localStorage.setItem("filterObjects", JSON.stringify(filterobject));
  //   setSelectedAreas([CityAreaName?.area]);
  //   // setAreaText(CityAreaName?.area)
  // } else {
  //   setFilterObjects((prevState) => ({
  //     ...prevState,
  //     area: [],
  //   }));
  //   const filterobject = filterObjects;
  //   filterobject["area"] = [];
  //   if (filterobject["date"] !== null) {
  //     filterobject["date"] = filterObjects?.date
  //       ?.toLocaleString("sv-SE")
  //       ?.replace(" ", "T");
  //   }
  //   localStorage.setItem("filterObjects", JSON.stringify(filterobject));
  //   setSelectedAreas([]);
  // }
  // }, []);

  useEffect(() => {
    function handleClickOutside(ref) {
      return function (event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowsearchList(false);
          setFilter(false);
          document.body.classList.remove("no-scroll");
          document
            .getElementsByClassName("filter-bg")[0]
            .classList.remove("blur-bg");
        }
      };
    }
    const handleSearchClick = handleClickOutside(SearchRef);
    const handleFilterClick = handleClickOutside(FilterRef);

    document.addEventListener("mousedown", handleSearchClick);
    document.addEventListener("mousedown", handleFilterClick);

    return () => {
      document.removeEventListener("mousedown", handleSearchClick);
      document.removeEventListener("mousedown", handleFilterClick);
    };
  }, [SearchRef, FilterRef]);

  const delayedSearch = useCallback(
    _.debounce(async (val) => {
      if (val !== "") {
        try {
          // setLoader(true)
          await CustomGetAPI("/Venue/GetCitiesByArea/" + val).then((result) => {
            if (result === undefined || result === "") {
              alert("Something went wrong");
            } else {
              result = JSON.parse(result);
              setShowsearchList(true);
              setSearchData(result?.cities);
            }
          });
        } catch (error) {
          // console.log(error);
        } finally {
          // setLoader(false)
        }
      } else {
        setShowsearchList(false);
      }
    }, 500),
    []
  );
  const delayedNameSearch = useCallback(
    _.debounce(async (val) => {
      setPageNumber(1);
      setVenuesData([]);
      if (val !== "") {
        try {
          getVenue(val);
        } catch (error) {
          // console.log(error);
        } finally {
          // setIsLoading(false);
        }
      } else {
        getVenue("");
      }
    }, 500),
    [CityAreaName]
  );

  const handleSearchChange = (e) => {
    const value = e.target.value;
    delayedSearch(value);
    setSearchText(value);
  };
  const handleSortClick = (optionValue) => {
    setSelectedSort(optionValue);
    setFilterObjects((prev) => ({
      ...prev,
      sortby: optionValue,
    }));
  };
  const handleSportsClick = (value, sportName) => {
    setActiveSport(value);
    setFilterObjects((prev) => ({
      ...prev,
      sport: value,
    }));
    setsportName(sportName);
  };
  useEffect(() => {
    CustomGetAPI(`/venue/GetSportID/${params.sportName}`).then((result) => {
      if (result === undefined || result === "") {
        alert("Something went wrong");
      } else {
        setSportId(result);
        setFilterObjects((prevState) => ({
          ...prevState,
          sport: result,
        }));
        // setIsLoading(true);
        // getVenue(result);
      }
    });
  }, [params.sportName]);

  useLayoutEffect(() => {
    if (CityAreaName?.city && initialLoad) {
      if (!isMobile) {
        setIsLoading(true);
        setPageNumber(1);
        setVenuesData([]);
        getVenue();
      }
    }
  }, [initialLoad, CityAreaName?.city, params.sportName, selectedAreas.length]);

  const getVenue = async (val = filterObjects?.name) => {
    // const timingIds = filterObjects?.timings.map((timing) => timing.value);
    try {
      const raw = JSON.stringify({
        UserId: userID ? userID : 0,
        cityname: CityAreaName?.city,
        Name: val,
        Sport: params.sportName,
        Date: filterObjects?.date?.split("T")[0],
        TimeId: parseInt(filterObjects?.timings?.value),
        Sortby: filterObjects?.sortby,
        areaname: selectedAreas?.join(","),
        PageNumber: PageNumber,
        PageSize: windowWidth < 990 ? 3 : 6,
        category: pathname?.split("/")[3],
        searchTime: filterObjects?.date?.split("T")[1].split(".")[0],
      });
      await CustomPostAPI("/Venue/NewGetAllVenues", raw).then((result) => {
        if (
          result === undefined ||
          result === "" ||
          result?.status === "Error"
        ) {
          alert("Something went wrong");
        } else {
          // console.log(result);
          result = JSON.parse(result);
          // console.log(result);

          setHasMore(result?.hasNext);
          setPageNumber((prevPage) => prevPage + 1);
          setVenuesData((prevData) => [...prevData, ...result?.venues]);
          // setFilterData(result.venues);
          setSportsData(result.allsport);
          if (pathname?.split("/")[4] != "all") {
            const sport = pathname?.split("/")[4];
            const sportmatch = result?.allsport?.some(
              (sportItem) =>
                sportItem?.label.toLocaleLowerCase() ===
                sport.toLocaleLowerCase()
            );
            if (!sportmatch) {
              navigate("/not-found");
            }
          }
        }
      });
    } catch (error) {
      console.error("NewGetAllVenues: ", error.message);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (pathname?.split("/")[4] != "all") {
      const sportid = SportsData?.find(
        (sport) =>
          sport?.label?.toLowerCase() ==
          pathname?.split("/")[4].toLocaleLowerCase()
      );
      setActiveSport(sportid?.value);
    } else {
      setActiveSport("0");
    }
  }, [SportsData]);
  const isLoggedIn = window.localStorage.getItem("UserMobileNo");
  const [showLogin, setshowLogin] = useState(false);

  const [isHovering, setIsHovering] = useState(-1);
  const [metaData, setMetaData] = useState();
  const pages = [
    {
      pagename: "all",
      title: `Cricbuddy | Book ${capitalizeWord(
        pathname?.split("/")[3]
      )} Venues in ${capitalizeWord(CityName, "-", " ")} Online`,
      desc: `${
        pathname?.split("/")[3] === "sports"
          ? `Discover and Book Sports Venues in ${capitalizeWord(
              CityName,
              "-",
              " "
            )} online with Cricbuddy.Book box cricket, pickleball, and more with ease. Explore nearby and top-rated venues.`
          : `Discover and Book events venues like - auditoriums, theatres, and community halls in ${capitalizeWord(
              CityName,
              "-",
              " "
            )} for seminars, open mic, karaoke and more.`
      }`,
      onPageData: `${
        pathname?.split("/")[3] === "sports"
          ? `Discover and book sports venues in ${capitalizeWord(
              CityName,
              "-",
              " "
            )} online with Cricbuddy. Whether you're looking to book and play sports like cricket, box-cricket, football, pickleball, go kart, and more, Cricbuddy provides hassle-free options. Find the perfect spot at nearby sports venues, stadiums, and complexes to enjoy your favorite games. Start booking your sports venues near you today.`
          : `Find the perfect venues for your event in ${capitalizeWord(
              CityName,
              "-",
              " "
            )}. We offer a wide range of spaces to suit every occasion. From corporate conferences to cultural events, our platform makes it easy to book event venues near you. Book auditoriums, theaters, open mics, live streaming events, stand-up comedy shows, corporate meetings, orchestra rehearsals, and housie games in ${capitalizeWord(
              CityName,
              "-",
              " "
            )} effortlessly. Enjoy easy booking, multiple options, and the best prices.`
      }`,
      onPageh1: `${
        pathname?.split("/")[3] === "sports"
          ? `Book Sports Venues in ${capitalizeWord(CityName, "-", " ")}`
          : `Book Events Venues in ${capitalizeWord(CityName, "-", " ")}`
      }`,
    },
    {
      pagename: "box-cricket",
      title: `Cricbuddy | Book Box Cricket Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Box Cricket Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy.Find the Ideal Box Cricket Turf for your game hassle-free.Play Box Cricket near me.`,
      onPageData: `Cricbuddy is your ultimate platform to book box cricket venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online. Whether you're looking to book box cricket grounds near you, find the best box cricket turf, or play at the finest box cricket venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}, Cricbuddy makes it easy and hassle-free. Explore a variety of box cricket turfs and book online to secure your ideal location. Enjoy playing box cricket near you with the convenience of booking through Cricbuddy. Whether it's the best box cricket ground in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} or a box cricket turf near you, we have you covered for your next game.`,
      onPageh1: `Book Box Cricket Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}`,
    },
    {
      pagename: "bowling-machine",
      title: `Cricbuddy | Book Bowling Machine Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Bowling Machine Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy.Find the Ideal Bowling Machine Turf for your game hassle-free.Play Bowling Machine near me.`,
      onPageData: `Cricbuddy is your ultimate platform to book bowling machine venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online. Whether you're looking to book bowling machine grounds near you, find the best bowling machine turf, or play at the finest bowling machine venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}, Cricbuddy makes it easy and hassle-free. Explore a variety of bowling machine turfs and book online to secure your ideal location. Enjoy playing bowling machine near you with the convenience of booking through Cricbuddy. Whether it's the best bowling machine ground in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} or a bowling machine turf near you, we have you covered for your next game.`,
      onPageh1: `Book Bowling Machine Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}`,
    },
    {
      pagename: "cricket-nets",
      title: `Cricbuddy | Book Cricket Nets Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Cricket Nets Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy.Find the Ideal Cricket Nets Turf for your game hassle-free.Play Cricket Nets near me.`,
      onPageData: `Cricbuddy is your ultimate platform to book cricket nets venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online. Whether you're looking to book cricket nets grounds near you, find the best cricket nets turf, or play at the finest cricket nets venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}, Cricbuddy makes it easy and hassle-free. Explore a variety of cricket nets turfs and book online to secure your ideal location. Enjoy playing cricket nets near you with the convenience of booking through Cricbuddy. Whether it's the best cricket nets ground in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} or a cricket nets turf near you, we have you covered for your next game.`,
      onPageh1: `Book Cricket Nets Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}`,
    },
    {
      pagename: "pickleball",
      title: `Cricbuddy | Book Pickleball Courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Pickleball Courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Find the perfect pickleball court for your game hassle-free. Play pickleball near me.`,
      onPageData: `Cricbuddy is your premier platform to book pickleball courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online. Whether you're searching for a pickleball court near you, wanting to play pickleball in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}, or looking to book the perfect pickleball venue, Cricbuddy makes it simple and hassle-free. Easily book pickleball courts online and find the ideal location for your next game. Whether it's a pickleball venue near you or a court in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}, we have everything you need for an enjoyable game.`,
      onPageh1: `Book Pickleball Courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}`,
    },
    {
      pagename: "cricket",
      title: `Cricbuddy | Book Cricket Ground in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Cricket Grounds in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy.Find the Ideal Cricket ground for your game hassle-free. Play cricket near me.`,
      onPageData: `Cricbuddy is your go-to platform to book cricket grounds near you in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}. Whether you're looking to book an open cricket ground near you or the best cricket venue near you, Cricbuddy makes the process simple and hassle-free. Explore and book cricket grounds online with ease and find the ideal cricket complex for your next game. Enjoy the convenience of booking a cricket ground near you and get ready to play cricket.`,
      onPageh1: `Book Cricket Ground in ${capitalizeWord(CityName, "-", " ")}`,
    },
    {
      pagename: "go-karting",
      title: `Cricbuddy | Book Go Karting Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Go karting Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Find the perfect track for your race hassle-free. Book go karting near me.`,
      onPageData: `Discover and book go karting venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Whether you're searching for the best go karting track near you or wanting to book a thrilling go-karting experience in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}, Cricbuddy makes it simple and hassle-free. Find the perfect track for your race and enjoy go karting near me with ease. Explore and book go karting venues online today.`,
      onPageh1: `Book Go Karting Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}`,
    },
    {
      pagename: "bowling",
      title: `Cricbuddy | Book Bowling Alleys in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online `,
      desc: `Discover and Book Bowling Alleys in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Find the perfect bowling game zone hassle-free. Book bowling venues online near me.`,
      onPageData: `Discover and book sports venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Whether you're looking to book and play sports like cricket, box-cricket, football, pickleball, go kart, and more, Cricbuddy provides hassle-free options. Find the perfect spot at nearby sports venues, stadiums, and complexes to enjoy your favorite games. Start booking your sports venues near you today.`,
    },
    {
      pagename: "football",
      title: `CricBuddy | Book Football Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Football venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with CricBuddy. Find the ideal football turf for your game hassle-free. Play Football near me.`,
      onPageData: `CricBuddy is your ultimate platform to book football venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online. Whether you're looking to book a football turf near you, find the best football ground, or secure a football pitch for your next game, CricBuddy makes it easy and hassle-free. Discover the ideal football turf in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} and book online with ease. Enjoy playing football near you with the convenience of booking through CricBuddy. From football turfs to pitches, we have everything you need to enjoy your game at the best football venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}.`,
      onPageh1: `Book Football Venues in ${capitalizeWord(CityName, "-", " ")}`,
    },
    {
      pagename: "auditorium",
      title: `Book Auditorium venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Book auditorium halls, theatres, and community halls in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} for events, conferences and more.Book Auditorium near me. `,
      onPageData: `Find the perfect auditorium hall for your event in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}. We offer a wide range of auditorium venues to suit every occasion. From corporate conferences to cultural events, our platform makes it easy to book auditoriums near you. Discover and book auditoriums, theaters, and community halls in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} effortlessly. Enjoy easy booking, multiple options, and the best prices.`,
      onPageh1: `Book Auditorium Venues in ${capitalizeWord(
        CityName,
        "-",
        " "
      )}`,
    },
    {
      pagename: "pool",
      title: `Cricbuddy | Book Pool Tables in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Pool Table in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Find the Ideal pool table for your game hassle-free. Play pool near me.`,
      onPageData: `Discover the perfect pool table or venue near you in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} with Cricbuddy. Our platform offers a wide range of options to suit your preferences. Easily find and book top-rated pool tables, parlors, clubs, and cafes. Enjoy a hassle-free booking process and experience the thrill of pool near you.`,
      onPageh1: `Book Pool Tables in ${capitalizeWord(CityName, "-", " ")}`,
    },
    {
      pagename: "snooker",
      title: `Cricbuddy | Book Snooker Tables in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Snooker in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Find the Ideal snooker table for your game hassle-free. Play Snooker near me.`,
      onPageData: `Discover the perfect snooker table or venue in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} with Cricbuddy. Easily find and book top-rated snooker tables, parlors, cafes, and halls. Whether you're looking for a casual game with friends or a competitive match, we've got you covered. Enjoy a hassle-free booking process and experience the thrill of snooker near you.`,
      onPageh1: `Book Snooker in ${capitalizeWord(CityName, "-", " ")}`,
    },
    {
      pagename: "badminton",
      title: `Cricbuddy | Book Badminton courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Badminton courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Find the Ideal Badminton court for your game hassle-free. Play Badminton near me.`,
      onPageData: `Discover the perfect badminton court in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} with Cricbuddy. Our platform offers a wide range of options to suit your preferences. Easily find and book top-rated badminton indoor and outdoor courts. Enjoy a hassle-free booking process and experience the thrill of badminton courts near you.`,
      onPageh1: `Book Badminton Courts in  ${capitalizeWord(
        CityName,
        "-",
        " "
      )}`,
    },
    {
      pagename: "tennis",
      title: `Cricbuddy | Book Tennis courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} Online`,
      desc: `Discover and Book Tennis courts in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} online with Cricbuddy. Find the Ideal Tennis court for your game hassle-free. Play Tennis near me.`,
      onPageData: `Discover the perfect tennis court in ${capitalizeWord(
        CityName,
        "-",
        " "
      )} with Cricbuddy. Our platform offers a wide range of options to suit your preferences. Easily find and book top-rated tennis indoor and outdoor courts. Enjoy a hassle-free booking process and experience the thrill of tennis courts near you.`,
      onPageh1: `Book Tennis Courts in  ${capitalizeWord(CityName, "-", " ")}`,
    },
  ];

  useLayoutEffect(() => {
    const page = pages.find(
      (page) => page.pagename === params.sportName.toLocaleLowerCase()
    );
    setMetaData(page);
  }, [params?.cityName, params.sportName]);

  useLayoutEffect(() => {
    setSportsOptions([
      { value: 0, label: `All-${capitalizeWord(pathname?.split("/")[3])}` },
      ...SportsData?.map((item) => ({
        value: item.value,
        label: item.label === "Cricket" ? "Cricket-Ground" : item.label,
      })),
    ]);
  }, [SportsData]);

  const selectedValue = sportsOptions?.find(
    (option) => parseInt(option?.value) === parseInt(filterObjects?.sport)
  );

  // useEffect(() => {
  //   if (CityAreaName?.area) {
  //     setSelectedAreas([CityAreaName?.area]);
  //     // setAreaText(CityAreaName?.area)
  //   } else {
  //     setSelectedAreas(filterObjects?.area);
  //     // setAreaText(filterObjects?.area.toLocaleLowerCase())
  //   }
  // }, [filterObjects, CityAreaName?.area]);
  const windowWidth = window.innerWidth;

  useEffect(() => {
    document.addEventListener("DOMContentLoaded", function () {
      const scrollContainer = document.querySelector(".scrollable-container");
      let isDown = false;
      let startX;
      let scrollLeft;

      scrollContainer?.addEventListener("mousedown", (e) => {
        isDown = true;
        scrollContainer.classList.add("active");
        startX = e.pageX - scrollContainer.offsetLeft;
        scrollLeft = scrollContainer.scrollLeft;
      });

      scrollContainer?.addEventListener("mouseleave", () => {
        isDown = false;
        scrollContainer.classList.remove("active");
      });

      scrollContainer?.addEventListener("mouseup", () => {
        isDown = false;
        scrollContainer.classList.remove("active");
      });

      scrollContainer?.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - scrollContainer.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        scrollContainer.scrollLeft = scrollLeft - walk;
      });
    });
  }, []);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F5F5F5",
      fontSize: "14px",
      border: "none",
    }),
  };

  // const handleCityChange = (e) => {
  //   const selectedCity = e.target.value.toLowerCase();
  //   setSelectedCity(selectedCity);
  //   localStorage.setItem("userLocation", selectedCity);
  //   window.location.href = `/venue-search/${selectedCity}/${pathname?.split("/")[3]
  //     }/all`;
  // };

  const handleHorizontalScroll = (letter) => {
    const element = document.getElementById(letter);
    element?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  };

  useEffect(() => {
    if (areaData?.length > 0) {
      const availLetters = areaData
        ?.filter((area) =>
          area?.addressline2?.toLowerCase()?.includes(areaText?.toLowerCase())
        )
        ?.map((area) => area?.addressline2[0]?.toUpperCase())
        ?.filter((letter, index, self) => self.indexOf(letter) === index);
      setAvailableLetters(availLetters);
    }
  }, [areaData, areaText]);

  useEffect(() => {
    if (!showAreas || !areaData?.length) return;
    const grouped = areaData
      ?.filter((area) =>
        area?.addressline2?.toLowerCase()?.includes(areaText?.toLowerCase())
      )
      ?.sort((a, b) => a.addressline2.localeCompare(b.addressline2))
      .reduce((acc, area) => {
        const letter = area.addressline2[0].toUpperCase();
        if (!acc[letter]) acc[letter] = [];
        acc[letter].push(area);
        return acc;
      }, {});

    const MAX_ROWS_PER_COLUMN = 7;
    const newColumns = [];
    let currentColumn = [];
    let remainingRows = MAX_ROWS_PER_COLUMN;

    Object.entries(grouped).forEach(([letter, areas]) => {
      let cityIndex = 0;
      let isFirstChunk = true;

      while (cityIndex < areas.length || isFirstChunk) {
        if (remainingRows === 0) {
          newColumns.push(currentColumn);
          currentColumn = [];
          remainingRows = MAX_ROWS_PER_COLUMN;
        }

        let spaceForAreas = isFirstChunk ? remainingRows - 1 : remainingRows;

        if (remainingRows >= 1) {
          const chunk = {
            letter: isFirstChunk ? letter : null,
            groupLetter: letter,
            areas: areas.slice(cityIndex, cityIndex + spaceForAreas),
          };

          currentColumn.push(chunk);
          cityIndex += spaceForAreas;
          remainingRows -= chunk.areas.length + (isFirstChunk ? 1 : 0);
          isFirstChunk = false;
        } else {
          newColumns.push(currentColumn);
          currentColumn = [];
          remainingRows = MAX_ROWS_PER_COLUMN;
        }
      }
    });

    if (currentColumn.length > 0) {
      newColumns.push(currentColumn);
    }

    setColumns(newColumns);
  }, [areaData, areaText, showAreas]);
  const [showHint, setShowHint] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHint(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <HelmetMetaTag
        titleName={metaData?.title}
        ogdesc={metaData?.desc}
        desc={metaData?.desc}
        canonical={window.location.href}
        ogtitle={metaData?.title}
        ogtype="website"
        ogurl={window.location.href}
      />
      <div className="px-md-5 px-2 filter-bg ">
        <div className="row mx-0 px-2 align-items-center">
          <div className="col-1 ps-0">
            <img
              src="/images/backArrow.svg"
              onClick={goToVenueSearch}
              style={{ cursor: "pointer" }}
            />
          </div>

          {windowWidth >= 900 ? (
            <>
              <div className="col-11 d-flex justify-content-end pe-0">
                <div className="col-md-2 col-7 d-flex align-items-center justify-content-center">
                  <LocationSearch />

                  {/* <input
                    value={searchText
                      .split("-")
                      .map((part, index, array) =>
                        index === array.length - 2 ? part + "," : part
                      )
                      .join(" ")}
                    onChange={(e) => {
                      handleSearchChange(e);
                    }}
                    type="text"
                    className="form-control Montserrat venueListingTopMenu h-100 h-100"
                    style={{ position: "relative", paddingLeft: "30px" }}
                  /> */}

                  {/* <>
                    <div
                      className="results-list"
                      style={{
                        zIndex: "9",
                        position: "absolute",
                      }}
                    >
                      {searchData.map((result, id) => {
                        return (
                          <div
                            className="search-result"
                            onClick={(e) =>
                              goToVenueList(result?.id, result?.name)
                            }
                            key={id}
                          >
                            {result?.name
                              ?.split("-")
                              .map((part, index, array) =>
                                index === array.length - 2 ? part + "," : part
                              )
                              .join(" ")}
                          </div>
                        );
                      })}
                    </div>
                  </>

                  <img
                    src="/images/LocationLatestIcon.svg"
                    alt="location"
                    className="locationSearch"
                  /> */}
                </div>
                <div className="col-md-2 col-5 me-2">
                  <input
                    type="text"
                    className="form-control customize-placeholder venueListingTopMenu h-100"
                    name="name"
                    placeholder="Venue Name"
                    value={filterObjects?.name}
                    style={{ paddingLeft: "10px" }}
                    onChange={(e) => {
                      handleChange(e);
                      handleNameSearch(e);
                    }}
                  />
                </div>
                <div className="col-md-2 col-5 mt-3 mt-md-0 me-2">
                  <Select
                    className="basic-single Montserrat venueListingTopMenu h-100"
                    styles={customStyles}
                    classNamePrefix="select"
                    value={selectedValue}
                    isSearchable="true"
                    name="sport"
                    options={sportsOptions}
                    onChange={(selectedOption) => {
                      handleChange({
                        target: {
                          name: "sport",
                          value: selectedOption?.value,
                          label:
                            selectedOption?.label === "Cricket-Ground"
                              ? "Cricket"
                              : selectedOption?.label,
                        },
                      });
                      filterVenues(
                        null,
                        null,
                        selectedOption?.value,
                        selectedOption?.label === "Cricket-Ground"
                          ? "Cricket"
                          : selectedOption?.label,
                        selectedAreas
                      );
                    }}
                  />
                  {/* <select
                id="selectSport"
                className="custom-select"
                aria-label="Select Sport"
                name="sport"
                value={filterObjects?.sport}
                onChange={(e) => {
                  handleChange(e);
                  const selectedOptionIndex = e.target.selectedIndex;
                  const selectedOptionLabel = e.target[selectedOptionIndex].text;
                  filterVenues(null, null, e.target.value, selectedOptionLabel);
                }}
              >
                <option value="0">Select Sports</option>
                {SportsData?.map((item, i) => (
                  <option key={i} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select> */}
                </div>
                {/* <div className="col-md-2 col-5 me-2">
                  <select
                    id="sortby"
                    className="custom-select Montserrat venueListingTopMenu h-100"
                    aria-label="sortby"
                    name="sortby"
                    value={filterObjects?.sortby}
                    onChange={(e) => {
                      handleChange(e);
                      filterVenues(null, e.target.value);
                    }}
                  >
                    <option value="0"> Latest Created</option>
                    <option value="1">Price: low to high</option>
                    <option value="2"> Price: high to low</option>
                  </select>
                </div> */}
                <div className="col-md-2 col-5 mt-3 mt-md-0 me-2 venue-listing-date-timepicker h-full">
                  <DatePicker
                    selected={
                      filterObjects.date ? new Date(filterObjects.date) : null
                    }
                    placeholderText="Check Availability"
                    onChange={(date) => {
                      setFilterObjects({ ...filterObjects, date: date });
                      if (
                        date &&
                        (date.getHours() !== 0 || date.getMinutes() !== 0)
                      ) {
                        filterVenues(date, null, null, null);
                      }
                    }}
                    showTimeSelect
                    dateFormat="dd-MM-yyyy hh:mm aa"
                    className="form-control Montserrat venueListingTopMenu h-100 customize-placeholder"
                  />
                </div>
                <div className="col-md-1 col-5 mt-3 mt-md-0">
                  <button
                    className="filterButtons px-1 w-100 h-100"
                    style={{ background: "#3C3C40", fontSize: "14px" }}
                    onClick={() => resetFilter()}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-5 d-flex px-1">
                <LocationSearch />

                {/* <img src="/images/red-location.svg" alt="location" /> */}
                {/* <select
                  name="SelectCity"
                  className="border-0 fw-semibold Montserrat"
                  id="SelectCity"
                  style={{
                    fontSize: "14px",
                    background: "transparent",
                    backgroundColor: "inherit",
                    color: "inherit",
                  }}
                  value={selectedCity}
                  onChange={handleCityChange}
                >
                  {cityData?.map((city, i) => (
                    <option key={i} value={city.CityAreaName?.city.toLowerCase()}>
                      {city.CityAreaName?.city}
                    </option>
                  ))}
                </select> */}
              </div>
              <div className="col-6 pe-0">
                <input
                  type="text"
                  className={`${
                    isSearch ? "show" : ""
                  } search-bg form-control customize-placeholder`}
                  placeholder="Search for Venues"
                  style={{ background: "#f3f3f3" }}
                  name="name"
                  value={filterObjects?.name}
                  onChange={(e) => {
                    handleChange(e);
                    handleNameSearch(e);
                  }}
                  onFocus={() => {
                    setIsSearch(true);
                  }}
                  onBlur={() => {
                    setIsSearch(false);
                  }}
                />
                {/* <img
    src="/images/search-icon-new.svg"
    alt="search"
    className="searchVenues"
  /> */}
              </div>
              {/* <div className="">
                {showHint && (
                  <div className="floating-voice-search-tag animate">Try voice search</div>
                )}
                <div className="mic-icon-fixed" onClick={() => setSpeechRecognitionModal(!speechRecognitionModal)}>
                  <img src="/images/voice-search-animation.gif" alt="voice-search-animation" className="mic-white" style={{ width: "30px" }} />
                </div>
              </div> */}
              <div className="">
                <img
                  className="filter-icon"
                  src="/images/filtervenues.svg"
                  alt=""
                  onClick={toggleFilters}
                />
              </div>

              <div className="px-3 my-3">
                <div className="row discountWrapper">
                  <div className="col-12 d-flex align-items-center px-2 py-3">
                    <img
                      src="/images/disount-img.svg"
                      alt="disountimg"
                      className="me-2"
                      style={{ height: "20px" }}
                    />
                    <label
                      className="fw-normal text-white Montserrat"
                      style={{ fontSize: "12px" }}
                    >
                      Get <span className="fw-bold">10% OFF</span> ON First
                      VENUE BOOKING
                      <br /> <small>Offer Valid on Selected Venues</small>{" "}
                      <br /> <small>(App Exclusive)</small>
                    </label>
                  </div>
                  {/* <div className="col-4">
                    <img
                      src="/images/girl-basketball.svg"
                      alt="girl-basketball"
                    />
                  </div> */}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="mt-md-3 py-2 px-3 px-md-2 d-flex flex-column flex-md-row justify-content-between align-items-md-center position-relative">
          <h1 className="px-0 venueListingH1 Montserrat fw-bold mb-0 col-md-9 col-12">
            {metaData && metaData?.onPageh1}
          </h1>
          {/* {areaData && areaData?.length > 0 && (
              <div className="scrollable-container">
                {areaData?.map((area) => (
                  <button
                    className={`${selecedArea.toLocaleLowerCase() ===
                      area?.addressline2.toLocaleLowerCase()
                      ? "active"
                      : ""
                      } areaBtn  me-3 mb-0`}
                    onClick={() => {
                      handleAreaChange(area?.addressline2);
                    }}
                  >
                    {area?.addressline2}
                  </button>
                ))}
              </div>
            )} */}
          {areaData && areaData?.length > 0 && (
            <div
              className="area-selection-container"
              style={{ zIndex: showAreas && 1051 }}
            >
              <div
                className={`position-relative d-flex gap-3 h-100 custom-w-100 bg-white rounded-top-4 py-2 ${
                  showAreas ? "shadow px-2 px-md-3" : ""
                }`}
                tabIndex={0}
                onBlur={(e) => {
                  if (!e.currentTarget.contains(e.relatedTarget)) {
                    setAreaText("");
                    document.getElementById("area-input").value = "";
                    setShowAreas(false);
                    setHoveredAlphabet("");
                    // document.body.style.overflowY = "auto"
                  }
                }}
              >
                {/* <div className="d-flex gap-3 align-items-center admin-stats-tab-wrapper h-100 p-1 p-md-2 custom-w-100">
                <img src="/images/areaSearch.svg" height={24} width={24} />
                <input
                  placeholder="Filter By Area..."
                  id="area-input"
                  type="text"
                  // value={areaText} 
                  onChange={(e) => setAreaText(e.target.value)}
                  onFocus={() => setShowAreas(true)}
                  className="border-0 admin-stats-placeholder w-100"
                  autoComplete="off"
                />
              </div>
              {showAreas &&
                <div className=" position-absolute top-100 p-3 z-3 bg-white shadow rounded-bottom-4 rounded-md-start-4 end-0 ">
                  {areaData?.length > 0 &&
                    <>
                      <div className="new-area-container">
                        {areaData
                          .sort((a, b) => {
                            // Prioritize the active button
                            if (selecedArea?.toLowerCase() === a.addressline2?.replaceAll(" ", "-")?.toLowerCase())
                              return -1;
                            if (selecedArea?.toLowerCase() === b.addressline2?.replaceAll(" ", "-")?.toLowerCase())
                              return 1;

                            // Sort alphabetically otherwise
                            return a.addressline2.localeCompare(b.addressline2);
                          })?.filter((searchArea) => searchArea?.addressline2?.toLowerCase()?.includes(areaText?.toLowerCase()))
                          .map((area) => (
                            <div className="col-6 col-md-3 pe-2">
                              <button
                                key={area.addressline2}
                                className={`${selecedArea?.toLowerCase() ===
                                  area.addressline2?.replaceAll(" ", "-")?.toLowerCase()
                                  ? "active"
                                  : ""} areaBtn mb-3 Montserrat w-100`}
                                onClick={() => {
                                  handleAreaChange(area.addressline2);
                                }}
                              >
                                {area.addressline2}
                              </button>
                            </div>
                          ))}
                      </div>
                      <div className="row justify-content-right mt-2">
                        <div className="col-md-3 col-6"><button className="filterButtons px-1 w-100 h-100" style={{ background: "#3C3C40", fontSize: "14px" }}>Reset</button></div>
                        <div className="col-md-3 col-6"><button className="btn-Banner-header px-1 w-100 h-100">Apply</button></div>
                      </div>
                    </>
                  }
                </div>
              } */}
                {showAreas && columns?.length > 4 && (
                  <div className="d-none d-md-flex align-items-center my-2 px-0">
                    {[...Array(26)].map((_, i) => {
                      const alphabet = String.fromCharCode(65 + i);
                      const isPresent = availableLetters.includes(alphabet);

                      return (
                        <div
                          onClick={() => {
                            if (isPresent) handleHorizontalScroll(alphabet);
                          }}
                          onMouseEnter={() => {
                            if (isPresent) setHoveredAlphabet(alphabet);
                          }}
                          onMouseLeave={() => setHoveredAlphabet("")}
                          className="cursor-pointer"
                        >
                          <label
                            key={alphabet}
                            className="me-2 pe-1 Montserrat cursor-pointer fw-semibold"
                            style={{
                              color: "#A6A6A6",
                              opacity: isPresent ? 1 : 0.2,
                              pointerEvents: isPresent ? "auto" : "none",
                              fontSize: "14px",
                            }}
                          >
                            {alphabet}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                )}
                {/* <div className="d-flex align-items-center">
                  <span className="voice-search-tag">Try voice search</span>
                  <div className="mic-square" onClick={() => setSpeechRecognitionModal(!speechRecognitionModal)}>
                    <img src="/images/voice-search-animation.gif" alt="voice-search-animation" className="mic-icon" style={{ width: "30px" }} />
                  </div>
                </div> */}
                <div
                  className="d-flex gap-3 align-items-center admin-stats-tab-wrapper p-1 custom-w-100"
                  style={{ height: "fit-content" }}
                >
                  <img src="/images/areaSearch.svg" className="img-fluid" />
                  <input
                    placeholder="Filter By Area..."
                    id="area-input"
                    type="text"
                    onChange={(e) => setAreaText(e.target.value)}
                    onFocus={() => setShowAreas(true)}
                    className="border-0 w-100 h-100 customize-placeholder"
                    autoComplete="off"
                  />
                </div>

                {showAreas && (
                  <div className="position-absolute top-100 px-3 px-md-0 py-3 z-3 bg-white shadow rounded-bottom-4 rounded-md-start-4 end-0 w-100">
                    {areaData?.length > 0 && (
                      <>
                        <div
                          className="new-area-container row mx-0 mx-md-3"
                          style={{
                            overflowY: columns.length > 4 ? "hidden" : "auto",
                            overflowX: columns.length > 4 ? "auto" : "hidden",
                          }}
                        >
                          <div
                            className={`${
                              columns?.length > 4
                                ? "d-flex flex-md-row flex-column flex-md-nowrap"
                                : "d-flex flex-column"
                            } mx-0 px-0`}
                          >
                            {columns.length > 0 ? (
                              columns.map((column, colIndex) => (
                                <div
                                  key={colIndex}
                                  className="custom-text-wrap me-md-3 pe-md-3"
                                >
                                  {column.map((chunk, chunkIndex) => (
                                    <div key={chunkIndex}>
                                      {chunk.letter && (
                                        <div
                                          id={chunk.letter || undefined}
                                          className={`fw-bold mb-3 ${
                                            columns?.length <= 4 && "d-none"
                                          } ${
                                            !hoveredAlphabet
                                              ? "opacity-100"
                                              : hoveredAlphabet?.toLowerCase() ===
                                                chunk?.groupLetter?.toLowerCase()
                                              ? "opacity-100"
                                              : "opacity-25"
                                          }`}
                                          style={{ lineHeight: "16px" }}
                                        >
                                          {chunk.letter}
                                        </div>
                                      )}
                                      {chunk.areas.map((area) => {
                                        const formattedArea = area.addressline2
                                          ?.replaceAll(" ", "-")
                                          ?.toLowerCase();
                                        const isActive =
                                          selectedAreas.includes(formattedArea);

                                        return (
                                          <label
                                            key={area.id}
                                            className={`cursor-pointer mb-3 Montserrat w-100 d-flex align-items-md-center gap-2 ${
                                              !hoveredAlphabet
                                                ? "opacity-100"
                                                : hoveredAlphabet?.toLowerCase() ===
                                                  chunk?.groupLetter?.toLowerCase()
                                                ? "opacity-100"
                                                : "opacity-25"
                                            }`}
                                            style={{ lineHeight: "16px" }}
                                          >
                                            <div className="checkbox-wrapper">
                                              <input
                                                type="checkbox"
                                                checked={isActive}
                                                onChange={() => {
                                                  if (!isLoading) {
                                                    setIsMobile(false);
                                                    setPageNumber(1);
                                                    const updatedAreas =
                                                      isActive
                                                        ? selectedAreas.filter(
                                                            (item) =>
                                                              item !==
                                                              formattedArea
                                                          )
                                                        : [
                                                            ...selectedAreas,
                                                            formattedArea,
                                                          ];

                                                    setSelectedAreas(
                                                      updatedAreas
                                                    );
                                                    const updatedFilter = {
                                                      ...filterObjects,
                                                      area: updatedAreas,
                                                    };

                                                    setFilterObjects(
                                                      updatedFilter
                                                    );
                                                    localStorage.setItem(
                                                      "filterObjects",
                                                      JSON.stringify(
                                                        updatedFilter
                                                      )
                                                    );
                                                    const isSportPage =
                                                      pathname?.includes(
                                                        "sports"
                                                      );
                                                    if (
                                                      updatedAreas.length === 1
                                                    ) {
                                                      navigate(
                                                        `/venue-search/${updatedAreas.join()}-${userLocation?.replaceAll(
                                                          " ",
                                                          "-"
                                                        )}/${
                                                          isSportPage
                                                            ? "sports"
                                                            : "events"
                                                        }/${
                                                          sportName ||
                                                          params?.sportName ||
                                                          "all"
                                                        }`
                                                      );
                                                    } else if (
                                                      updatedAreas.length !==
                                                        1 ||
                                                      (updatedAreas.length ===
                                                        1 &&
                                                        !pathname?.includes(
                                                          updatedAreas.join()
                                                        ))
                                                    ) {
                                                      navigate(
                                                        `/venue-search/${userLocation?.replaceAll(
                                                          " ",
                                                          "-"
                                                        )}/${
                                                          isSportPage
                                                            ? "sports"
                                                            : "events"
                                                        }/${
                                                          sportName ||
                                                          params?.sportName ||
                                                          "all"
                                                        }`
                                                      );
                                                    }
                                                  }
                                                }}
                                              />
                                            </div>
                                            {area.addressline2}
                                          </label>
                                        );
                                      })}
                                    </div>
                                  ))}
                                </div>
                              ))
                            ) : (
                              <>No Areas Found. Try a different search</>
                            )}
                          </div>
                          {/* {
                        areaData
                          .filter((searchArea) =>
                            searchArea?.addressline2
                              ?.toLowerCase()
                              ?.includes(areaText?.toLowerCase())
                          )
                          .sort((a, b) => {
                            const aSelected = selectedAreas.includes(
                              a.addressline2.replaceAll(" ", "-").toLowerCase()
                            );
                            const bSelected = selectedAreas.includes(
                              b.addressline2.replaceAll(" ", "-").toLowerCase()
                            );

                            if (aSelected && !bSelected) return -1;
                            if (!aSelected && bSelected) return 1;

                            return a.addressline2.localeCompare(b.addressline2);
                          })
                          .sort((a, b) => a.addressline2.localeCompare(b.addressline2))
                          .reduce((acc, city) => {
                            const letter = city.cityName[0].toUpperCase();
                            if (!acc[letter]) acc[letter] = [];
                            acc[letter].push(city);
                            return acc;
                          }, {})
                          .map((area) => {
                            const formattedArea = area.addressline2
                              ?.replaceAll(" ", "-")
                              ?.toLowerCase();
                            const isActive = selectedAreas.includes(formattedArea);

                            return (
                              <div className="col-6 col-md-3 pe-2" key={area.id}>
                                <label
                                  style={{lineHeight: '16px'}}
                                  className={`${isActive ? "active" : ""} areaBtn mb-3 Montserrat w-100 d-flex align-items-center gap-1`}
                                >
                                  <input 
                                    type="checkbox" 
                                    className=" border-0"
                                    checked={isActive} 
                                    onChange={() => {
                                      const updatedAreas = isActive
                                        ? selectedAreas.filter((item) => item !== formattedArea)
                                        : [...selectedAreas, formattedArea];

                                      setSelectedAreas(updatedAreas);
                                      handleAreaChange(updatedAreas);
                                    }}
                                  /> 
                                  {area.addressline2}
                                </label>
                              </div>
                            );
                          })} */}
                        </div>

                        {/* <div className="row justify-content-end mt-2 mx-0">
                        <div className="col-md-3 col-6 ps-0">
                          <button
                            className="filterButtons px-1 w-100 h-100"
                            style={{ background: "#3C3C40", fontSize: "14px" }}
                            onClick={() => setSelectedAreas([])}
                          >
                            Reset
                          </button>
                        </div>
                        <div className="col-md-3 col-6 pe-0">
                          <button
                            className="btn-Banner-header px-1 w-100 h-100"
                            onClick={() => {
                              handleAreaChange(selectedAreas);
                              // setShowAreas(false);
                            }}
                          >
                            Apply
                          </button>
                        </div>
                      </div> */}
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {selectedAreas && selectedAreas.length > 0 && (
          <div className="mt-md-2 mx-3 mx-md-2 d-flex flex-md-wrap flex-nowrap align-items-center gap-2 automatic-scroll">
            {selectedAreas.map((areas) => {
              const FormattedAreas = areas?.replaceAll("-", " ");
              return (
                <label
                  className="d-flex align-items-center gap-2 py-1 px-2 rounded text-nowrap text-white text-capitalize fw-medium Montserrat custom-fs-12"
                  style={{ backgroundColor: "#e7666a" }}
                >
                  {FormattedAreas}
                  <img
                    src="/images/CrossIcon.svg"
                    alt="CrossIcon"
                    height={16}
                    width={16}
                    className="cursor-pointer"
                    onClick={() => {
                      setPageNumber(1);
                      const FilterArray = selectedAreas.filter(
                        (area) => area?.toLowerCase() !== areas?.toLowerCase()
                      );
                      const filterObject = JSON.parse(
                        localStorage.getItem("filterObjects")
                      );
                      const updateObject = {
                        ...filterObject,
                        area: FilterArray,
                      };
                      setSelectedAreas(FilterArray);
                      setFilterObjects(updateObject);
                      localStorage.setItem(
                        "filterObjects",
                        JSON.stringify(updateObject)
                      );
                      const isSportPage = pathname?.includes("sports");
                      if (FilterArray.length === 1) {
                        navigate(
                          `/venue-search/${FilterArray.join()}-${userLocation?.replaceAll(
                            " ",
                            "-"
                          )}/${isSportPage ? "sports" : "events"}/${
                            sportName || params?.sportName || "all"
                          }`
                        );
                      } else if (
                        FilterArray.length !== 1 ||
                        (FilterArray.length === 1 &&
                          !pathname?.includes(FilterArray.join()))
                      ) {
                        navigate(
                          `/venue-search/${userLocation?.replaceAll(
                            " ",
                            "-"
                          )}/${isSportPage ? "sports" : "events"}/${
                            sportName || params?.sportName || "all"
                          }`
                        );
                      }
                    }}
                  />
                </label>
              );
            })}
          </div>
        )}
        <div className="mt-md-4 mt-3">
          {isLoading ? (
            <>
              <Loader mt="20%" />
            </>
          ) : (
            <>
              <InfiniteScroll
                dataLength={venuesData?.length}
                next={() => getVenue()}
                hasMore={HasMore}
                loader={
                  <img
                    className="mb-4 blur-bg"
                    height="50px"
                    width="50px"
                    src="/images/loder.svg"
                    // style={{ marginLeft: "45%" }}
                  />
                }
                className="row"
              >
                {venuesData?.length != 0 ? (
                  <>
                    {venuesData
                      ?.filter((venue) => venue?.isPreferredArea === 0)
                      .map((venue, index) => (
                        <VenueCard
                          key={`top-${index}`}
                          venue={venue}
                          index={index}
                          CityAreaName={CityAreaName}
                          handleVenueListing={handleVenueListing}
                          setVenuesData={setVenuesData}
                        />
                      ))}
                    {filterObjects?.area?.length > 1 && (
                      <div className="section-header d-flex align-items-md-center justify-content-between flex-wrap px-4">
                        <span className="title-text">
                          More Venues In Your City
                        </span>
                        <div className="flex-line"></div>
                      </div>
                    )}
                    {venuesData
                      ?.filter((venue) => venue?.isPreferredArea === 1)
                      .map((venue, index) => (
                        <VenueCard
                          key={`bottom-${index}`}
                          venue={venue}
                          index={index}
                          CityAreaName={CityAreaName}
                          handleVenueListing={handleVenueListing}
                          setVenuesData={setVenuesData}
                        />
                      ))}
                  </>
                ) : (
                  <div className="citiesbox text-center border-0 mb-5">
                    We couldn't find any venues available in your city right
                    now. Please try again later.
                  </div>
                )}
              </InfiniteScroll>

              <div className="row mx-0 px-md-5 px-2 py-3 venueListingBorder">
                <div className="col-12 ">
                  <p className="m-0 fw-600">
                    {metaData && metaData?.onPageData}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div
        className={`fade modal-backdrop ${
          Filter || isSearch || showAreas ? "show" : "d-none"
        }`}
      ></div>
      <Modal
        show={showLogin}
        onHide={() => setshowLogin(false)}
        // backdrop="static"
      >
        {/* <Modal.Header closeButton onClick={() => setshowLogin(false)}>
                    <Modal.Title className="colorClass">Confirm Phone Number</Modal.Title>
                  </Modal.Header> */}

        <Modal.Body>
          <img
            src="/images/Closeicon.svg"
            className="closeicon"
            alt=""
            onClick={() => setshowLogin(false)}
          />
          <VerifyPhoneNumber
            phonenumber={isLoggedIn}
            setshowLogin={setshowLogin}
            isfromvenueowner={false}
          />
        </Modal.Body>

        {/* <Modal.Footer>
                    <small className="d-none bookederror text-center text-danger w-100"></small>
                    <button
                     
                      className="venueListingTop booking w-100"
                    >
                     Verify
                    </button>
                  </Modal.Footer> */}
      </Modal>
      <div
        className={`filter-popup ${Filter ? "visible" : "d-none"}`}
        ref={FilterRef}
      >
        <div className="popup-content" style={{ padding: "20px" }}>
          {/* <div className="text-center">
            <div
              className="btn-group"
              role="group"
              aria-label="Basic radio toggle button group"
            >
              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                value="Filters"
                id="btnradio1"
                autoComplete="off"
                checked={selectedOption === "Filters"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              <label
                className="btn btn-custom d-flex align-items-center"
                htmlFor="btnradio1"
              >
                <img
                  src="/images/filter-icon.svg"
                  alt="filter"
                  className={`me-1 ${
                    selectedOption === "Filters" ? "checked-img" : ""
                  }`}
                />
                Filters
              </label>

              <input
                type="radio"
                className="btn-check"
                name="btnradio"
                value="Sort"
                id="btnradio2"
                autoComplete="off"
                checked={selectedOption === "Sort"}
                onChange={(e) => setSelectedOption(e.target.value)}
              />
              <label
                className="btn btn-custom d-flex align-items-center"
                htmlFor="btnradio2"
              >
                <img
                  src="/images/sort-icon.svg"
                  alt="sort"
                  className={`me-1 ${
                    selectedOption === "Sort" ? "checked-img" : ""
                  }`}
                />
                Sort
              </label>
            </div>
          </div> */}
          {selectedOption === "Filters" && (
            <>
              <div
                className="accordion custom-accordion mt-3"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button Montserrat fw-semibold"
                      style={{ background: "white" }}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      {capitalizeWord(pathname?.split("/")[3])}
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#accordionExample"
                  >
                    <div
                      className="accordion-body"
                      style={{ background: "white" }}
                    >
                      <div
                        className="row"
                        style={{ maxHeight: "200px", overflow: "scroll" }}
                      >
                        <div className="col-6 p-2 ">
                          <button
                            className={`sportsButton px-2 py-2 ${
                              activeSport === "0" ? "activeIndex" : ""
                            }`}
                            onClick={() => handleSportsClick("0", "all")}
                          >
                            All-
                            {capitalizeWord(pathname?.split("/")[3])}
                          </button>
                        </div>
                        {SportsData.map((sport, index) => {
                          const imageSrc = venueSportsData(sport.label);
                          return (
                            <div key={index} className="col-6 p-2 ">
                              <button
                                className={`sportsButton px-2 py-2 ${
                                  activeSport === sport.value
                                    ? "activeIndex"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSportsClick(sport.value, sport.label)
                                }
                              >
                                {sport.label}
                                {imageSrc ? (
                                  <img
                                    src={`/images/${imageSrc}`}
                                    alt="sport icon"
                                    className={`pe-2 ${
                                      activeSport === sport.value
                                        ? "checked-img"
                                        : ""
                                    }`}
                                    style={{
                                      height:
                                        sport?.label === "Cricket" ||
                                        sport?.label === "Box-Cricket"
                                          ? "20px"
                                          : "20px",
                                    }}
                                  />
                                ) : null}
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed Montserrat fw-semibold"
                      style={{ background: "white" }}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Availability
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div
                      className="accordion-body"
                      style={{ background: "white" }}
                    >
                      <div className="row">
                        <div className="col-12 mb-2 venue-listing-date-timepicker">
                          {/* <DatePicker
                            type="date"
                            className="form-control Montserrat venueListingTopMenu h-100"
                            min={new Date()}
                            name="date"
                            value={filterObjects?.date}
                            onChange={(date) => handleChange({target: {value: date, name: "date"}})}
                            showTimeSelect
                          /> */}
                          <DatePicker
                            selected={
                              filterObjects.date
                                ? new Date(filterObjects.date)
                                : null
                            }
                            placeholderText="Check Availability"
                            onChange={(date) =>
                              setFilterObjects({ ...filterObjects, date: date })
                            }
                            showTimeSelect
                            dateFormat="dd-MM-yyyy hh:mm aa"
                            className="form-control Montserrat venueListingTopMenu h-100 customize-placeholder"
                          />
                        </div>

                        {/* {TimingsButtonData.map((time, index) => (
                          <div key={index} className={`col-6 py-2`}>
                            <button
                              className={`sportsButton px-2 w-100 ${
                                activeTime === time?.value ? "activeIndex" : ""
                              }`}
                              onClick={() => handleSelectTimings(time?.value)}
                            >
                              {time.TimingBtnText}
                              <img
                                src={time?.TimimgImage}
                                alt="image"
                                className={`me-1 ${
                                  activeTime === time?.value
                                    ? "checked-img"
                                    : ""
                                }`}
                              />
                            </button>
                          </div>
                        ))} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed Montserrat fw-semibold"
                      style={{ background: "white" }}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Filter By Area
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionExample"
                  >
                    <div
                      className="accordion-body"
                      style={{ background: "white" }}
                    >
                      <div className="row">
                        <div className="col-12">
                          <div
                            className="d-flex gap-3 align-items-center admin-stats-tab-wrapper p-1 custom-w-100"
                            style={{ height: "fit-content" }}
                          >
                            <img
                              src="/images/areaSearch.svg"
                              className="img-fluid"
                            />
                            <input
                              placeholder="Filter By Area..."
                              id="area-input"
                              type="text"
                              onChange={(e) => setAreaText(e.target.value)}
                              className="border-0 w-100 h-100 customize-placeholder"
                              autoComplete="off"
                            />
                          </div>
                          <div className="col-12">
                            <div
                              className="mt-3 overflow-y-scroll"
                              style={{ maxHeight: "225px" }}
                            >
                              {areaData?.length > 0 &&
                                areaData
                                  ?.filter((area) =>
                                    area?.addressline2
                                      ?.toLowerCase()
                                      ?.includes(areaText?.toLowerCase())
                                  )
                                  ?.sort((a, b) => {
                                    if (
                                      selectedAreas?.includes(
                                        a.addressline2
                                          ?.replaceAll(" ", "-")
                                          ?.toLowerCase()
                                      )
                                    )
                                      return -1;
                                    if (
                                      selectedAreas?.includes(
                                        b.addressline2
                                          ?.replaceAll(" ", "-")
                                          ?.toLowerCase()
                                      )
                                    )
                                      return 1;
                                    return a.addressline2.localeCompare(
                                      b.addressline2
                                    );
                                  })
                                  ?.map((area) => {
                                    const formattedArea = area.addressline2
                                      ?.replaceAll(" ", "-")
                                      ?.toLowerCase();
                                    const isActive =
                                      selectedAreas.includes(formattedArea);

                                    return (
                                      <div className="d-flex align-items-center gap-2 mb-2">
                                        <div className="checkbox-wrapper">
                                          <input
                                            type="checkbox"
                                            id={area.addressline2}
                                            checked={isActive}
                                            onChange={() => {
                                              setIsMobile(true);
                                              const updatedAreas = isActive
                                                ? selectedAreas.filter(
                                                    (item) =>
                                                      item !== formattedArea
                                                  )
                                                : [
                                                    ...selectedAreas,
                                                    formattedArea,
                                                  ];
                                              setSelectedAreas(updatedAreas);
                                            }}
                                          />
                                        </div>
                                        <label htmlFor={area.addressline2}>
                                          {area.addressline2}
                                        </label>
                                      </div>
                                    );
                                  })}
                            </div>
                          </div>
                        </div>

                        {/* {TimingsButtonData.map((time, index) => (
                          <div key={index} className={`col-6 py-2`}>
                            <button
                              className={`sportsButton px-2 w-100 ${
                                activeTime === time?.value ? "activeIndex" : ""
                              }`}
                              onClick={() => handleSelectTimings(time?.value)}
                            >
                              {time.TimingBtnText}
                              <img
                                src={time?.TimimgImage}
                                alt="image"
                                className={`me-1 ${
                                  activeTime === time?.value
                                    ? "checked-img"
                                    : ""
                                }`}
                              />
                            </button>
                          </div>
                        ))} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* {selectedOption === "Sort" && (
            <div className="text-start d-flex flex-column py-4">
              <div
                className={`sort-option Montserrat ${
                  selectedSort === "0" ? "activeIndex" : ""
                }`}
                onClick={() => handleSortClick("0")}
              >
                Latest Created
              </div>
              <div
                className={`sort-option Montserrat ${
                  selectedSort === "1" ? "activeIndex" : ""
                }`}
                onClick={() => handleSortClick("1")}
              >
                Price: low to high
              </div>
              <div
                className={`sort-option Montserrat ${
                  selectedSort === "2" ? "activeIndex" : ""
                }`}
                onClick={() => handleSortClick("2")}
              >
                Price: high to low
              </div>
            </div>
          )} */}
          <div className="d-flex justify-content-evenly my-3">
            <button
              className="venueListingFilterBtn"
              style={{ background: "#3C3C3C" }}
              onClick={() => resetFilter()}
            >
              Reset Filter
            </button>
            <button
              className="venueListingFilterBtn"
              style={{ background: "#BA5457" }}
              onClick={() => filterVenues()}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>
      {speechRecognitionModal && (
        <VoiceSearchFeature
          show={speechRecognitionModal}
          onHide={() => setSpeechRecognitionModal(!speechRecognitionModal)}
          filterVenues={filterVenues}
          CityAreaArray={CityAreaArray}
          SportsData={SportsData}
          CityName={CityAreaName?.city}
          areaData={areaData}
        />
      )}
    </>
  );
}

const VenueCard = ({
  venue,
  index,
  CityAreaName,
  handleVenueListing,
  setVenuesData,
}) => {
  const [isHovering, setIsHovering] = useState(null);
  const handleSavedVal = async (flag) => {
    setVenuesData((prevVenues) => {
      const updatedVenues = prevVenues.map((venueItem) => {
        if (venueItem.id === venue.id) {
          return { ...venueItem, isSaved: !flag };
        }
        return venueItem;
      });
      return updatedVenues;
    });
    var raw = JSON.stringify(!flag);
    window.localStorage.setItem("RedirectURL", window.location.href);
    await PostAPI(`/Venue/ManageSavedVenue/${venue?.id}`, raw).then(
      (result) => {
        if (result === undefined || result === "") {
          alert("Something went wrong");
        } else {
          result = JSON.parse(result);
          if (result?.status === "Success") {
            // console.log(result);
          }
        }
      }
    );
  };
  return (
    <>
      <div className="col-md-4 col-12 mb-md-5 mb-4 px-4" key={index}>
        <Link
          className="text-decoration-none"
          to={
            `/venue-search/${
              CityAreaName?.area
                ? `${venue?.address
                    ?.replaceAll(" ", "-")
                    ?.toLocaleLowerCase()}-${CityAreaName?.city?.replaceAll(
                    " ",
                    "-"
                  )}`
                : CityAreaName?.city?.replaceAll(" ", "-")
            }/` +
            venue?.name?.toLocaleLowerCase()?.trim()?.split(" ")?.join("-")
          }
          onClick={() => handleVenueListing(venue?.name)}
        >
          <Card
            className="cursor-pointer h-100"
            style={{
              borderBottom: "0px, 0px, 0.5px, 0px solid #E1E1E1",
              borderRadius: "16px",
              boxShadow: "0px 0px 5px 0px #0000001A",
              position: "relative",
              border:
                venue?.hasPackage && venue?.diffPercentage > 0
                  ? "2px solid #E7666A"
                  : "1px solid #00000066",
            }}
          >
            <Card.Body
              className="py-0 px-0 d-flex flex-column"
              onMouseEnter={() =>
                setIsHovering((prev) => {
                  return prev ? prev : index;
                })
              }
              onMouseLeave={() => setIsHovering(null)}
            >
              <div className="venueImages position-relative mb-3">
                {venue?.hasPackage && venue?.diffPercentage > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-1px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 1,
                      color: "white",
                      background: "#E7666A",
                      textAlign: "center",
                      width: "max-content",
                      fontWeight: "600",
                      fontSize: "14px",
                      borderBottomLeftRadius: "5px",
                      borderBottomRightRadius: "5px",
                      padding: "8px 15px",
                    }}
                  >
                    Special Package Deal{" "}
                    <b>({venue?.diffPercentage.toFixed(0)}% OFF)</b>
                  </div>
                )}

                {venue?.hasOffers && (
                  <img
                    src="/images/specialoffer.svg"
                    className="img-fluid"
                    alt="Special Offer"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      right: "10px",
                      zIndex: 1,
                      maxWidth: "100px",
                    }}
                  />
                )}

                {venue?.isFeatured && (
                  <img
                    src="/images/CbFeatured.svg"
                    className="img-fluid"
                    alt="Featured"
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "1px",
                      zIndex: 1,
                      maxWidth: "100px",
                    }}
                  />
                )}

                <div
                  className="row position-relative"
                  style={{ padding: "0 12px" }}
                >
                  <div className="col-12 px-0">
                    <button
                      className="saveVenueButton d-flex align-items-center"
                      style={{ right: "6%", top: "2%", bottom: "auto" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSavedVal(venue?.isSaved);
                      }}
                    >
                      <img
                        src={`/images/${
                          venue?.isSaved ? "heart_filled" : "heart_empty"
                        }.svg`}
                        alt=""
                        className="cursor-pointer"
                        style={{ width: "26px", height: "26px" }}
                      />
                    </button>
                    <Carousel
                      controls={false}
                      interval={isHovering === index ? 3000 : null}
                      indicators={true}
                    >
                      {venue?.venueImages?.map((data, i) => (
                        <Carousel.Item className="Carousel-radius" key={i}>
                          <LazyLoadingImg
                            src={data}
                            alt="image"
                            title=""
                            className="venuePhotos w-100"
                          />
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  </div>
                </div>
              </div>

              <div className="cursor-pointer">
                <div className="row mx-0 mt-1">
                  <div className="col-md-6 col-7 pe-0">
                    <h2
                      className="Montserrat fw-semibold m-0"
                      style={{ color: "black", fontSize: "16px" }}
                    >
                      {venue?.name}
                    </h2>
                  </div>
                  <div className="col-md-6 col-5 ps-0 text-end">
                    <div className="text-end">
                      {venue?.venueSports?.map((data, i) => (
                        <>
                          {i < 2 && (
                            <div className="sportimage ms-2">
                              <img
                                src={`/images/${venueSportsData(data?.name)}`}
                                className="img-fluid"
                                alt={data?.name}
                                title={data?.name}
                                style={{
                                  borderRadius: "11px",
                                  padding: "3px",
                                  height: "30px",
                                  width: "30px",
                                }}
                              />
                            </div>
                          )}
                          {i === 2 && venue?.venueSports?.length > 2 && (
                            <div
                              className="mx-lg-1 mx-1 Montserrat"
                              style={{ fontSize: "14px" }}
                            >
                              + {venue?.venueSports?.length - 2} more
                            </div>
                          )}
                        </>
                      ))}
                      {venue?.venueSports?.length === 0 && (
                        <span className="venueText">No sports available</span>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <p
                      className="Montserrat"
                      style={{
                        color: "#5c5c5c",
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                    >
                      {venue?.address}{" "}
                      {venue?.distanceInKm?.toFixed(1) > 0.0 &&
                        `(~${venue?.distanceInKm?.toFixed(1)} km)`}
                    </p>
                  </div>
                </div>
                <div className="row align-items-center mx-0 mb-3">
                  <div className="col-6">
                    <div className="venuePriceDetails">
                      <span className="text-black fw-bold">
                        ₹{venue?.averagePrice}
                      </span>
                      <span className="">&nbsp;onwards</span>
                    </div>
                  </div>
                  {[4, 5, 6].includes(venue?.isAcrive) && (
                    <div className="col-md-6 col-6 text-end h-100">
                      <button className="venueListingBooknow">
                        Book Now
                        <img
                          src="/images/white-arrow.svg"
                          alt="arrow"
                          className="mx-1"
                        />
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        </Link>
      </div>
    </>
  );
};

// const Modals = ({ show, onHide, filterVenues, CityAreaArray, SportsData, CityName, areaData }) => {
//   const {
//     transcript,
//     listening,
//     resetTranscript,
//     browserSupportsSpeechRecognition,
//   } = useSpeechRecognition();

//   const [loader, setLoader] = useState(false);
//   const [matchedSport, setMatchedSport] = useState("");
//   const [matchedDate, setMatchedDate] = useState("");
//   const [matchedLocation, setMatchedLocation] = useState("");
//   const [matchedAreaLocation, setMatchedAreaLocation] = useState("");
//   const [screens, setScreens] = useState(false);
//   const [error, setError] = useState("");

//   const debounceTimer = useRef(null);
//   const lastTranscriptRef = useRef("");

//   const normalize = (str) => str?.toLowerCase().replace(/[-\s]/g, "");

//   const isValidSport =
//     matchedSport && ((matchedSport === "all" || matchedSport === "All") ||
//       SportsData.some(
//         (sport) => normalize(sport.label) === normalize(matchedSport)
//       ));

//   const isValidLocation =
// (matchedLocation === "" ||
//   CityAreaArray.some(
//     (city) => normalize(city.cityName) === normalize(matchedLocation)
//   ));

//   // useEffect(() => {
//   //   if (show) {
//   //     resetTranscript();
//   //     SpeechRecognition.startListening({ continuous: true, interimResults: true });
//   //   } else {
//   //     SpeechRecognition.stopListening();
//   //   }
//   // }, [show]);

//   useEffect(() => {
//     if (!transcript) return;

//     if (debounceTimer.current) clearTimeout(debounceTimer.current);

//     debounceTimer.current = setTimeout(() => {
//       if (lastTranscriptRef.current !== transcript) {
//         lastTranscriptRef.current = transcript;
//         fetchWitAI(transcript);
//       }
//     }, 2000);

//     return () => clearTimeout(debounceTimer.current);
//   }, [transcript]);

//   const fetchWitAI = async (text) => {
//     SpeechRecognition.stopListening();
//     try {
//       setLoader(true);
//       const res = await fetch(
//         "https://api.wit.ai/message?v=20250624&q=" + encodeURIComponent(text),
//         {
//           headers: {
//             Authorization: "Bearer IZKV3Y4XOWFAHQZDPU7QK7FMB7L2OKUN",
//           },
//         }
//       );

//       const data = await res.json();
//       const entities = data.entities;

//       const sportEntity = entities["sport:sport"]?.[entities["sport:sport"]?.length - 1];
//       if (sportEntity?.value) {
//         const possiblePickleBall = entities["sport:sport"]
//           .map((e) => e.body.toLowerCase())
//           .sort()
//           .join(" ");
//         if (possiblePickleBall === "ball pickle" || possiblePickleBall === "pickle ball") {
//           setMatchedSport("Pickleball");
//         } else setMatchedSport(sportEntity.value);
//       } else {
//         setMatchedSport("all");
//       }

//       const locationEntity = entities["wit$location:location"]?.[entities["wit$location:location"]?.length - 1];
//       if (locationEntity?.body) {
//         if (locationEntity?.body) {
//           const loc = locationEntity.body.toLowerCase();
//           const vagueTerms = [
//             "around me",
//             "near me",
//             "nearby",
//             "close to me",
//             "in my area",
//             "close by",
//             "close around",
//             "near here",
//             "somewhere near me",
//             "near my place",
//             "near my location",
//             "near this place",
//             "near my home",
//             "near where i live",
//             "close to where i am",
//             "in this area",
//             "somewhere nearby",
//             "near current location",
//             "close to my area",
//             "near current place"
//           ];
//           let cityName = "";
//           if (vagueTerms.includes(loc)) {
//             const city = await getUserCityFromIP();
//             cityName = city || "";
//             setMatchedLocation(city || "");
//           } else {
//             cityName = locationEntity.body
//             setMatchedLocation(locationEntity.body);
//           }
//           if (CityName && CityName?.toLowerCase() === cityName?.toLowerCase()) {
//             const lastMatchedArea = findLastMatchedArea(text, areaData?.map((a) => a.addressline2));
//             if (lastMatchedArea) {
//               setMatchedAreaLocation(lastMatchedArea);
//             }
//           } else {
//             const response = await CustomGetAPI(
//               `/venue/uniqueaddresses/${cityName}?category=${window.location.pathname?.split("/")[3]}`
//             );
//             const result = JSON.parse(response);
//             if (result?.status === "success") {
//               const newAreaList = result?.data;
//               const lastMatchedArea = findLastMatchedArea(text, newAreaList?.map((a) => a.addressline2));
//               if (lastMatchedArea) {
//                 setMatchedAreaLocation(lastMatchedArea);
//               }
//             }
//           }
//         }
//       }

//       const dateEntity = entities["wit$datetime:datetime"]?.[entities["wit$datetime:datetime"]?.length - 1];
//       if (dateEntity?.value) {
//         setMatchedDate(dateEntity?.value);
//       }
//     } catch (error) {
//       console.error("❌ Wit.ai fetch error:", error);
//     } finally {
//       setLoader(false);
//     }
//   };
//   const findLastMatchedArea = (text, areas) => {
//     const matched = areas
//       .filter((a) =>
//         text.toLowerCase().includes(a?.toLowerCase())
//       );
//     return matched.length > 0 ? matched[matched.length - 1] : "";
//   };
//   const getUserCityFromIP = async () => {
//     try {
//       const res = await fetch("https://ipapi.co/json");
//       const data = await res.json();
//       return data.city;
//     } catch (error) {
//       console.error("IP geolocation failed:", error);
//       return "";
//     }
//   };
//   const submit = () => {
//     setError("");

//     if (!isValidSport) {
//       setError("Sport not recognized. Please try again.");
//       return;
//     }

//     if (!isValidLocation) {
//       setError("Location not recognized. Please try again.");
//       return;
//     }

//     filterVenues(matchedDate, null, null, matchedSport, matchedAreaLocation, matchedLocation);
//   };

//   if (!browserSupportsSpeechRecognition) {
//     return (
//       <div className="alert alert-danger mt-3">
//         ❌ Browser doesn't support speech recognition.
//       </div>
//     );
//   }
//   const startListening = () => {
//     resetTranscript();
//     SpeechRecognition.startListening({ continuous: true, interimResults: true });
//     setScreens(true);
//   };

//   const stopListening = () => {
//     SpeechRecognition.stopListening();
//   };

//   return (
//     <Modal show={show} onHide={onHide} size="lg" centered>
//       <Modal.Body>
//         <div>
//           <img src="/images/Closeicon.svg" alt="Closeicon" className="float-end" onClick={onHide} />
//           <div class="tag-container">
//             <div class="tag">Search for cricket venues dsfslfgiewgrywegr</div>
//             <div class="tag">Search for cricket venues near me</div>
//             <div class="tag">Search for cricket venues</div>
//             <div class="tag">Search for cricket</div>
//             <div class="tag">Search for cricket venues</div>
//           </div>
//           {!screens ? <>
//             <div className="row mt-3 justify-content-center">
//               <button
//                 className="col-3 btn btn-primary d-flex justify-content-center align-items-center"
//                 onClick={startListening}
//                 style={{ background: "#E7666A", border: "#E7666A" }}
//               >
//                 <span>Start Voice Search</span>&nbsp;<span>(Beta)</span>
//               </button>
//             </div></> : <>
//             {listening ? (
//               <div className="mb-3 d-flex flex-column align-items-center">
//                 <div className="mb-2 mic-text">Listening...</div>
//                 <div className="mic-circle">
//                   <img src="/images/voice-search-animation.gif" alt="voice-search-animation" className="mic-icon" />
//                 </div>
//               </div>
//             ) : (
//               <div className="mb-3 d-flex flex-column align-items-center">
//                 <div className="mic-circle">
//                   <img src="/images/microphone-recording.png" alt="microphone-recording" className="mic-icon-red" />
//                 </div>
//               </div>
//             )}

//             <div className="card mb-3">
//               <div className="card-body">
//                 <p className="card-text" style={{ minHeight: "80px" }}>
//                   {transcript || <em>Start speaking</em>}
//                 </p>
//               </div>
//             </div>

//             <div className="row mt-3 justify-content-center">
//               <button
//                 className="col-3 btn btn-secondary me-4"
//                 style={{ color: "#E7666A", border: "#E7666A", background: "transparent" }}
//                 onClick={() => {
//                   resetTranscript();
//                   setMatchedSport("");
//                   setMatchedDate("");
//                   setMatchedLocation("");
//                   setError("");
//                   SpeechRecognition.startListening({ continuous: true, interimResults: true });
//                 }}
//               >
//                 Reset
//               </button>

//               <button
//                 className="col-3 btn btn-primary d-flex justify-content-center align-items-center"
//                 onClick={submit}
//                 style={{ background: "#E7666A", border: "#E7666A" }}
//                 disabled={loader}
//               >
//                 Confirm
//                 {loader && (
//                   <img
//                     height={"20px"}
//                     width={"20px"}
//                     src="/images/loder.svg"
//                     style={{ marginLeft: "10px" }}
//                   />
//                 )}
//               </button>
//             </div>

//             {error && (
//               <div className="text-danger text-center mt-3 fw-bold">
//                 {error}
//               </div>
//             )}
//           </>}

//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };
